import { MODAL_ROUTES, type ModalRoute } from './config.const'
import translations from './impact-navigation.translations'

export interface ImpactNavigationItem {
  label: { id: string; defaultMessage: string }
  route: ModalRoute
  icon: string
  /** Center-cropped into a circle by `ChoiceStep`, so keep the subject centered. */
  image: string
}

export const IMPACT_NAVIGATION: ImpactNavigationItem[] = [
  {
    label: translations.environmentalImpactButton,
    route: MODAL_ROUTES.ENVIRONMENTAL_IMPACT,
    icon: '/mine-my-phone/icons/plant--flat.svg',
    image: '/mine-my-phone/images/impacts/environmental.jpg',
  },
  {
    label: translations.humanImpactButton,
    route: MODAL_ROUTES.HUMAN_IMPACT,
    icon: '/mine-my-phone/icons/group--flat.svg',
    image: '/mine-my-phone/images/impacts/human.jpg',
  },
  {
    label: translations.geopoliticalImpactButton,
    route: MODAL_ROUTES.GEOPOLITICAL_IMPACT,
    icon: '/mine-my-phone/icons/world--flat.svg',
    image: '/mine-my-phone/images/impacts/geopolitical.jpg',
  },
]
